<template>
  <div
    @click="fileClick"
    @dragenter="commonHandler"
    @dragleave="commonHandler"
    @dragover="commonHandler"
    @drop="drop"
  >
    <input ref="fileInput" type="file" hidden multiple :disabled="disabled" @change="inputChange" />
    <slot />
  </div>
</template>

<script>
  /**
   * Компонент для загрузки файлов. Отрабатывает перенос файлов в окно браузера, клик и выкидывает событие со списком
   * объектов с загруженными файлами
   */
  export default {
    name: 'FileUpload',
    model: {
      prop: 'files',
      event: 'select',
    },
    props: {
      /**
       * Список загружаемых файлов
       * @model
       */
      files: {
        type: Array,
        default: () => [],
      },

      /**
       * Доступные форматы для реализации проверок форматов при загрузке и вывода сообщений об ошибке
       */
      allowedFormats: {
        type: Array,
        default: null,
      },

      /**
       * Недоступные форматы для реализации проверок форматов при загрузке и вывода сообщений об ошибке
       */
      disallowedFormats: {
        type: Array,
        default: null,
      },

      /**
       * Максимальный размер загружаемого файла в мегабайтах
       */
      maxSize: {
        type: Number,
        default: null,
      },

      /**
       * Максимальное количество файлов
       */
      maxCount: {
        type: Number,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      files(val) {
        if (!val || !val.length) this.$refs.fileInput.value = [];
      },
    },
    methods: {
      uploadFiles(files) {
        if (this.maxCount !== null && this.files.length + files.length > this.maxCount) {
          alert(
            `${this.$t('You are trying to upload too many upload files')}. ` +
              `${this.maxCount} ${this.$t('is allowed')}`
          );
          return;
        }

        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          if (this.disallowedFormats !== null) {
            const format = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
            if (this.disallowedFormats.indexOf(format) !== -1) {
              alert(
                `${this.$t(
                  "Files mustn't have the following format"
                )}: ${this.disallowedFormats.join(', ')}`
              );
              return;
            }
          } else if (this.allowedFormats !== null) {
            const format = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
            if (this.allowedFormats.indexOf(format) === -1) {
              alert(
                `${this.$t('Files must have the following format')}: ${this.allowedFormats.join(
                  ', '
                )}`
              );
              return;
            }
          }
          if (this.maxSize !== null) {
            if (file.size > this.maxSize * 1024 * 1024) {
              alert(`${this.$t('The maximum file size is')} ${this.maxSize} ${this.$t('MB')}`);
              return;
            }
          }
        }

        /**
         * Событие, вызываемое при загрузке новых файлов
         * @event change
         */
        this.$emit('select', [...this.files, ...files]);
        this.$refs.fileInput.value = [];
      },
      fileClick() {
        this.$refs.fileInput.click();
      },
      commonHandler(event) {
        event.preventDefault();
        /**
         * Прокидывает события перемещения файлов в окно браузера
         * @event dragleave
         */
        /**
         * Прокидывает события перемещения файлов в окно браузера
         * @event dragenter
         */
        /**
         * Прокидывает события перемещения файлов в окно браузера
         * @event dragover
         */
        this.$emit(event.type);
      },
      drop(event) {
        event.preventDefault();
        this.uploadFiles(event.dataTransfer.files);
      },
      inputChange(event) {
        this.uploadFiles(event.target.files);
      },
      clearInput() {
        this.$refs.fileInput.value = '';
      },
    },
  };
</script>

<style scoped>
  input {
    display: none;
  }
</style>
